export default __webpack_public_path__ + "static/media/EG_Snappy-4.95d15d69.wav";